import React from 'react';

import CashAccepterStep from './CashAccepterStep';
import PrintReceiptStep from './PrintReceiptStep';
import FarewellStep from './FarewellStep';
import EmailAddressStep from './EmailAddressStep';
import { StepName } from 'helpers/constants';
import ApplicationSelect from './ApplicationSelect';
export { default as Collection } from './Collection';
export { default as CollectionSummary } from './CollectionSummary';
export { default as CollectionSuccess } from './CollectionSuccess';

export const StepComponents = {
    [StepName.CashAccepter]: <CashAccepterStep />,
    [StepName.PrintReceipt]: <PrintReceiptStep />,
    [StepName.EmailAddress]: <EmailAddressStep />,
    [StepName.Farewell]: <FarewellStep />,
    [StepName.ApplicationSelect]: <ApplicationSelect />,
};
